export const AUTH_ROUTES = {
  BASE: 'auth',
  REGISTER: 'register',
  LOGIN: 'login',
  RESET_PASSWORD: 'reset-password',
  SET_NEW_PASSWORD: 'set-password',
  TWO_FACTOR: 'two-factor',
};
